var _a;
import { ChainId } from "@shared/utils/config/networks";
// Address mappings for different chains
export var addressMappings = (_a = {},
    _a[ChainId.ETHEREUM] = { address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2', subTitle: 'ETH' },
    _a[ChainId.BASE] = { address: '0x4200000000000000000000000000000000000006', subTitle: 'ETH' },
    _a[ChainId.ARBITRUM] = { address: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1', subTitle: 'ETH' },
    _a[ChainId.OPTIMISM] = { address: '0x4200000000000000000000000000000000000006', subTitle: 'ETH' },
    _a[ChainId.POLYGON] = { address: '0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270', subTitle: 'POL' },
    _a[ChainId.BSC] = { address: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c', subTitle: 'BNB' },
    _a['43114'] = { address: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7', subTitle: 'AVAX' },
    _a);
// Constants
var SOLANA_NATIVE_ADDRESS = 'So11111111111111111111111111111111111111112';
var NATIVE_ADDRESS = '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee'; // Replace with actual NATIVE_ADDRESS
/**
 * Transforms address based on input and mappings
 * @param {string} address - The original address
 * @param {string} networkId - The network ID
 * @returns {Object} - Transformed address, tradeSubAddress, and subTitle
 */
export function transformAddress(address, networkId) {
    var defaultAddress = "0x0000000000000000000000000000000000000000";
    var secondDefault = "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee";
    var tradeSubAddress;
    var subTitle;
    if (address === "1nc1nerator11111111111111111111111111111111") {
        address = SOLANA_NATIVE_ADDRESS;
        tradeSubAddress = SOLANA_NATIVE_ADDRESS;
    }
    else if ((address === defaultAddress || address === secondDefault) && addressMappings[Number(networkId)]) {
        address = addressMappings[Number(networkId)].address;
        tradeSubAddress = NATIVE_ADDRESS;
        networkId = (Number(networkId) === ChainId.BASE ||
            Number(networkId) === ChainId.ETHEREUM ||
            Number(networkId) === ChainId.OPTIMISM ||
            Number(networkId) === ChainId.ARBITRUM) ? '1' : networkId;
    }
    return { address: address, tradeSubAddress: tradeSubAddress, subTitle: subTitle, networkId: networkId };
}
